import { authService } from './auth/authService';

export const getToken = async (forceRefresh: boolean = false) => {
  return authService.getToken(forceRefresh);
};
